
<script>
import { app } from "../../application.js";
import editParameterValueComponent from "../editParameterValue.vue";
import genericConfiguratorComponent from "./genericConfigurator.vue";

export default {
    extends: genericConfiguratorComponent,
    name: "configurator30Component",

    data() {
        return {
            app: app,
            beforeRouteLeaveResolved: false,
            window_width: window.innerWidth
        };
    },
    components: { 
        editParameterValueComponent 
    },    

};
</script>
